import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaDollarSign, FaMoneyCheck, FaPlus, FaTimes } from 'react-icons/fa';
import StepProgressBar from './StepProgressBar';

const PaymentModeModal = ({ show, onHide, onNext, currentStep }) => {
  const [selectedMode, setSelectedMode] = useState('');

  const paymentModes = [
    {
      id: 'cash',
      icon: <FaDollarSign className="text-success" size={24} />,
      title: 'Cash On Hand',
      subtitle: 'Distributor paid via Cash',
      balance: '-8957'
    },
    {
      id: 'cheque',
      icon: <FaMoneyCheck className="text-danger" size={24} />,
      title: 'Paid-Out Cheque',
      subtitle: '',
      balance: ''
    },
    {
      id: 'new',
      icon: <FaPlus className="text-primary" size={24} />,
      title: 'Add New Account (F4)',
      subtitle: 'New Bank Account or Digital Wallet or POS',
      balance: ''
    }
  ];

  const handleModeSelect = (mode) => {
    setSelectedMode(mode);
  };

  const handleNext = () => {
    if (selectedMode) {
      onNext(selectedMode);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" dialogClassName="custom-modal-width">
      <Modal.Header className="border-0 pb-0">
        <div className="w-100">
          {/* Header Content */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h5 className="mb-0 fw-bold fs-5">Step 1 of 3: Select a Payment Mode</h5>
              <small className="text-muted">Select an option from the below list</small>
            </div>
            <Button variant="link" onClick={onHide} className="p-0 text-secondary">
              <FaTimes size={20} />
            </Button>
          </div>
          {/* <StepProgressBar currentStep={currentStep} totalSteps={3} /> */}
        </div>
      </Modal.Header>
      
      <Modal.Body className="pt-2" style={{height:'400px'}}>
        <div className="row mb-3">
          <div className="col-6">
            <small className="text-uppercase fw-bold text-muted">PAYMENT ACCOUNT</small>
          </div>
          <div className="col-6 text-end">
            <small className="text-uppercase fw-bold text-muted">CURRENT BAL</small>
          </div>
        </div>

        {paymentModes.map((mode) => (
          <div
          
            key={mode.id}
            className={`d-flex align-items-center p-3 mb-2 border rounded cursor-pointer ${
              selectedMode === mode.id ? 'border-success bg-light' : 'border-light'
            }`}
             onClick={() => {
    handleModeSelect(mode.id); 
    handleNext(); 
  }}
            style={{ cursor: 'pointer' }}
          >
            <div className="me-3">
              {mode.icon}
            </div>
            <div className="flex-grow-1">
              <div className="fw-bold">{mode.title}</div>
              {mode.subtitle && <small className="text-muted">{mode.subtitle}</small>}
            </div>
            {mode.balance && (
              <div className="text-danger fw-bold">
                {mode.balance}
              </div>
            )}
            <div className="ms-2">
              <i className="fas fa-chevron-right text-muted"></i>
            </div>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          {/* Left side - Empty for consistency with other steps */}
          <div></div>
          
          {/* Right side - Continue button */}
          <Button 
            className='gradient-dark-button'
            onClick={handleNext}
            disabled={!selectedMode}
          >
            Continue
          </Button>
        </div>
      </Modal.Footer>

      <style jsx>{`
        .cursor-pointer:hover {
          background-color: #f8f9fa !important;
        }
        kbd {
          background-color: #e9ecef;
          color: #495057;
          padding: 0.2rem 0.4rem;
          border-radius: 0.25rem;
          font-size: 0.8rem;
        }
          .custom-modal-width {
    max-width: 600px !important; /* or any px/% value */
    width: 600px !important;
  }
      `}</style>
    </Modal>
  );
};

export default PaymentModeModal;
